module.exports = __webpack_public_path__ + "static/img/qiangcha.edc466b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/qiangcha.png
// module id = c9Ik
// module chunks = 24